<div class="position-relative swappable-inputs">
    <ng-content></ng-content>
    <button type="button" (click)="swap()" *ngIf="isSwappable" class="btn btn--square btn--scaling swap-btn">
        <span class="icon icon-flip-route"></span>
    </button>
</div>
